import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _SubscriptionGetter = Getter.of();
export const _SubscriptionResponseGetter = Getter.of();
export const _SubscriptionsGetter = Getter.of();
export const _SubscriptionsResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _SubscriptionResponse2Subscription = _Response2ResponseData();
export const _SubscriptionsResponse2Subscriptions = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _Subscription2Attributes = Fold.compose(_SubscriptionGetter, Res._Response(), Lens.prop("attributes"));
export const _SubscriptionAttributes2Status = Fold.compose(_Subscription2Attributes, Lens.prop("status"));
export const _SubscriptionAttributes2Type = Fold.compose(_Subscription2Attributes, Lens.prop("type"));
export const _SubscriptionAttributes2UserId = Fold.compose(_Subscription2Attributes, Lens.prop("userId"));
export const _SubscriptionAttributes2StartDate = Fold.compose(_Subscription2Attributes, Lens.prop("startDate"));
export const _SubscriptionAttributes2EndDate = Fold.compose(_Subscription2Attributes, Lens.prop("endDate"));
export const _SubscriptionAttributes2NextRenewalDate = Fold.compose(_Subscription2Attributes, Lens.prop("nextRenewalDate"));
export const _SubscriptionAttributes2NextRetryDate = Fold.compose(_Subscription2Attributes, Lens.prop("nextRetryDate"));
export const _SubscriptionAttributes2CancelationDate = Fold.compose(_Subscription2Attributes, Lens.prop("cancelationDate"));
export const _SubscriptionAttributes2PreviousSubscriptionId = Fold.compose(_Subscription2Attributes, Lens.prop("previousSubscriptionId"));
export const _SubscriptionAttributes2CancelationAllowed = Fold.compose(_Subscription2Attributes, Lens.prop("cancelationAllowed"));
export const _SubscriptionAttributes2PricePlanChangedDate = Fold.compose(_Subscription2Attributes, Lens.prop("pricePlanChangedDate"));
export const _SubscriptionAttributes2MinimumTermEndDate = Fold.compose(_Subscription2Attributes, Lens.prop("minimumTermEndDate"));
export const _Subscription2PaymentMethod = Fold.compose(_SubscriptionGetter, Res._Rel("paymentMethod"));
export const _Subscription2ExternalVoucher = Fold.compose(_SubscriptionGetter, Res._Rel("externalVoucher"));
export const _Subscription2Product = Fold.compose(_SubscriptionGetter, Res._Rel("product"));
export const _Subscription2PricePlan = Fold.compose(_SubscriptionGetter, Res._Rel("pricePlan"));

